import * as Form from '../../../components/form'
import * as Request from '../../../request'
import * as TypesMember from '../types'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

type AttributeActions = Actions.UpdateAttributeAction &
                        Actions.EditAttributeAction &
                        Request.SuccessAction
export const memberDetailsReducer =
  (state: Form.State<Form.State<TypesMember.MemberDetailFormFields>>, action: AttributeActions) => {
  switch (action.type) {
    case Constants.ADD_MEMBER_DETAIL_ATTRIBUTE:
      return {
        ...state,
        fields: {
          ...state.fields,
          attributes: [
            ...state.fields.attributes,
            {
              index: state.fields.attributes.length,
              is_editing: true,
              name: '',
              value: '',
            },
          ],
        },
      }
    case Constants.CLICK_MEMBER_DETAIL_ATTRIBUTE:
        return {
          ...state,
          fields: {
            ...state.fields,
            attributes: [
              ...state.fields.attributes.map(
                (e: Types.Attribute) => ({
                  ...e,
                  is_editing: e.index === action.index,
                }),
              ),
            ],
          },
        }
    case Constants.EDIT_MEMBER_DETAIL_ATTRIBUTE:
        return {
          ...state,
          fields: {
            ...state.fields,
            attributes: [
              ...state.fields.attributes.slice(0, action.index),
              {
                ...state.fields.attributes[action.index],
                is_dirty: true,
                name: action.field.name,
                value: action.field.value,
              },
              ...state.fields.attributes.slice(action.index + 1),
            ],
          },
        }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/pages/member-details/attributes/reducer.ts